import React, { useState } from "react";
import styled from "styled-components";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Nav = styled.nav`
  display: none;
  justify-content: space-around;
  align-items: center;
  min-height: 92px;
  background-color: ${({ theme }) => theme.colours.white};
  border-bottom: 1px solid ${({ theme }) => theme.colours.lightGrey};
  position: sticky;
  top: -1px;
  left: 0;
  z-index: 10001;

  @media (${({ theme }) => theme.mq.m}) {
    display: flex;
  }
`;

const MobileNavContainer = styled.div`
  height: 92px;
  background-color: ${({ theme }) => theme.colours.white};
  border-bottom: 1px solid ${({ theme }) => theme.colours.lightGrey};
  position: sticky;
  top: 0;
  left: 0;
  margin-bottom: 100px;
  z-index: 10001;

  @media (${({ theme }) => theme.mq.m}) {
    display: none;
  }
`;

const DropdownToggle = styled.button`
  display: flex;
  justify-content: space-between;
  text-align: left;
  padding: 40px 30px 30px;
  width: 100%;
  border: none;
  font-size: 16px;
  line-height: 1;
  color: ${({ theme, $colour = "grey" }) => theme.colours[$colour]};
  outline: none;
  background-color: transparent;
  font-family: "neue-haas-grotesk-display", sans-serif;
`;

const Dropdown = styled.ul`
  height: ${({ $isOpen }) => ($isOpen ? "auto" : 0)};
  padding-bottom: ${({ $isOpen }) => ($isOpen ? "30px" : 0)};
  border-bottom: ${({ theme, $isOpen }) =>
    $isOpen && `1px solid ${theme.colours.lightGrey}`};
  overflow: hidden;
  background: ${({ theme }) => theme.colours.white};
`;

const DropdownItem = styled.li`
  padding: 30px 0;
`;

const DropdownItemLink = styled.a`
  display: block;
  padding: 5px 30px;
  text-decoration: none;
  font-size: 16px;
  color: ${({ theme, $colour, $isActive }) =>
    $isActive ? theme.colours[$colour] : theme.colours.lightGrey};
`;

const Item = styled(AnchorLink)`
  text-decoration: none;
  text-align: center;
  color: ${({ theme, $colour, $isActive }) =>
    $isActive ? theme.colours[$colour] : theme.colours.lightGrey};
  text-align: center;
  font-size: 16px;

  @media (${({ theme }) => theme.mq.l}) {
    font-size: 18px;
  }
`;

export const CaretSvg = styled.svg`
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : undefined)};
  transition: transform 0.2s ease-in-out;
`;

export function ToggleCaret({ isOpen }) {
  return (
    <CaretSvg
      $isOpen={isOpen}
      width="30"
      height="17"
      viewBox="0 0 30 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M29 1L15 15L1 1" stroke="black" strokeWidth="2" />
    </CaretSvg>
  );
}

function Subnavigation({ subnavItems, slug, inViewItem }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const activeItem =
    subnavItems.find((item) => item.component.anchorId === inViewItem) ||
    subnavItems[0];

  return (
    <>
      <MobileNavContainer>
        <DropdownToggle
          $colour={activeItem?.colour}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          {activeItem.title}
          <ToggleCaret $isOpen={isDropdownOpen} />
        </DropdownToggle>
        <Dropdown $isOpen={isDropdownOpen}>
          {subnavItems.map((item) => (
            <DropdownItem key={item.id}>
              <DropdownItemLink
                $isActive={inViewItem === item.component.anchorId}
                $colour={item.colour}
                onClick={() => setIsDropdownOpen(false)}
                href={`${slug}#${item.component.anchorId}`}
              >
                {item.title}
              </DropdownItemLink>
            </DropdownItem>
          ))}
        </Dropdown>
      </MobileNavContainer>
      <Nav>
        {subnavItems.map((item) => (
          <Item
            key={item.id}
            $colour={item.colour}
            $isActive={inViewItem === item.component.anchorId}
            to={`${slug}#${item.component.anchorId}`}
          >
            {item.title}
          </Item>
        ))}
      </Nav>
    </>
  );
}

export default Subnavigation;
